import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth/AuthProvider';

const Login: React.FC = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await api.post('/auth/login', {
                email,
                password
            });

            if (response.data.status) {
                const { token, user, perfis } = response.data;
                const fullUser = { ...user, perfis };

                localStorage.setItem('perfis', JSON.stringify(perfis));

                login(token, fullUser);

                // Redirecionamento baseado no perfil
                if (perfis && perfis.id === 1) {
                    navigate('/dashboard-admin');
                } else {
                    navigate('/dashboard-cliente');
                }
            } else {
                setError(response.data.message || 'Falha no login. Verifique suas credenciais.');
            }

        } catch (err: any) {
            console.error('Login error:', err);
            setError(err.response?.data?.message || 'Falha no login. Verifique suas credenciais.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="relative flex min-h-screen w-full flex-col items-center justify-center bg-[#f7f9fc] dark:bg-[#101922] font-sans">
            <div className="w-full max-w-md px-4">
                <div className="flex flex-col items-center gap-4 mb-8">

                    <h2 className="text-2xl font-bold text-[#333333] dark:text-white">Acesse sua conta</h2>
                </div>

                <div className="rounded-xl border border-gray-200 dark:border-gray-700/50 bg-white dark:bg-[#111827] p-6 sm:p-8 shadow-sm">
                    {error && (
                        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                            {error}
                        </div>
                    )}
                    <form className="space-y-6" onSubmit={handleLogin}>
                        <div>
                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="email">E-mail</label>
                            <input
                                className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow"
                                id="email"
                                placeholder="seu.email@exemplo.com"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-600 dark:text-gray-400 mb-1.5" htmlFor="password">Senha</label>
                            <input
                                className="w-full bg-white dark:bg-[#283039] text-[#333333] dark:text-white border border-[#e0e0e0] dark:border-[#3b4754] rounded-lg h-11 px-4 focus:ring-2 focus:ring-[#137fec] focus:border-[#137fec] transition-shadow"
                                id="password"
                                placeholder="Sua senha"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-[#137fec] focus:ring-[#137fec] border-gray-300 rounded" />
                                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900 dark:text-gray-300">Lembrar-me</label>
                            </div>
                            <div className="text-sm">
                                <Link className="font-medium text-[#137fec] hover:underline" to="/esqueceu-senha">
                                    Esqueceu a senha?
                                </Link>
                            </div>
                        </div>
                        <button
                            type="submit"
                            className="w-full flex items-center justify-center rounded-lg h-12 px-6 bg-[#137fec] text-white text-base font-bold hover:bg-opacity-90 transition-colors shadow-lg shadow-[#137fec]/30 disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={loading}
                        >
                            {loading ? 'Entrando...' : 'Entrar'}
                        </button>
                    </form>
                    <div className="mt-6 text-center">
                        <p className="text-sm text-gray-600 dark:text-gray-400">
                            Não tem uma conta? <Link className="font-medium text-[#137fec] hover:underline" to={"/cadastro"}>Cadastre-se</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
